import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {SystemEntity} from './system.entity';

@EntityTable('app', '574ea4bc-cc58-40df-b267-13fd333dd96a')
export class AppEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.ANY)
    public menu: any;
}
